export function checkForHTMLTags(test?: string): boolean {
  if(test != null)
    return /<\/?[a-z][\s\S]*>/i.test(test) || /&([a-z0-9]+|#[0-9]{1,7}|#x[0-9a-f]{1,7});/gi.test(test);
  else
    return false
}
